import { useState } from "react";
import { Resources, useResource } from "Translations/Resources";
import { IconButton, Tooltip, Box } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Admin.Campaigns.Table;

type CodeCellProps = {
  code: string;
  color?: string | null;
};

export const CodeCell = ({ code, color }: CodeCellProps) => {
  const [copied, setCopied] = useState(false);
  const { t } = useResource();

  const domain = window.location.origin;
  const campaignUrl = `${domain}${appUrl("campaign")}/${code}`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(campaignUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Tooltip title={copied ? t(RESOURCES.UrlCopied) : t(RESOURCES.CopyUrl)}>
        <IconButton
          onClick={handleCopy}
          size="small"
          sx={{ padding: 0.5, color: color || undefined }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Box component="code" sx={{ fontSize: "0.875rem" }}>
        {code}
      </Box>
    </Box>
  );
};
